import { render, staticRenderFns } from "./DemoProgress.vue?vue&type=template&id=13fedc95"
import script from "./DemoProgress.vue?vue&type=script&lang=js"
export * from "./DemoProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports